module.exports = __webpack_public_path__ + "img/traffic-light-red.2556b04a.svg";